module.exports = __webpack_public_path__ + "img/login-bg.03505ff9.svg";